const BASE_KEY = 'settings.materials.material-definitions.delete.bulk';

export const BULK_DELETE_MATERIALS_KEY = {
    confirmTitle: `${BASE_KEY}.confirm-title`,
    confirmButton: `${BASE_KEY}.confirm-button`,
    confirmMessage: `${BASE_KEY}.confirm-message`,
} as const;
